import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgStackImageIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="stack_image_svg__nc-icon-wrapper">
      <path
        d="M52 10H12V6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2Z"
        data-color="color-2"
      />
      <path d="M59 12H5a2 2 0 0 0-2 2v44a2 2 0 0 0 2 2h54a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2Zm-38 8a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm31.87 29.493A1 1 0 0 1 52 50H12a1 1 0 0 1-.832-1.555l8-12a1 1 0 0 1 1.539-.152l7.185 7.185L39.2 28.4a.973.973 0 0 1 .852-.4 1 1 0 0 1 .8.484l12 20a1 1 0 0 1 .018 1.009Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgStackImageStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgStackImageIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const StackImageIcon: any = SvgStackImageStyle;
export default StackImageIcon;
